import { Component, OnInit, Inject, Optional, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { Methods } from "../../../shared/methods";
import { InventoryAttribute } from "../../../models/inventoryAttribute";
import swal from "sweetalert2";
import { SecurazeService } from "../../../services/securaze.service";
import { MobilesdevicesService } from "../../../services/mobilesdevices.service";
declare const $: any;
@Component({
  selector: "app-inventory-attributes",
  templateUrl: "./inventory-attributes.component.html",
  styleUrls: ["./inventory-attributes.component.css"],
})
export class InventoryAttributesComponent implements OnInit {
  @Input() deepSearch;
  @Input() serialN;
  @Input() incommingId;
  @Input() incommingType;
  public margen = "100px;";

  public mtds: Methods = new Methods();
  public sn;
  public id;
  public loading = false;

  public identity;
  public token;

  public inventory: InventoryAttribute = new InventoryAttribute();

  public disabled = true;

  public batteries: string[][];
  public components: string[][];
  public cpus: string[][];
  public hdds: string[][];
  public memories: string[][];
  public networks: string[][];
  public system: string[][];
  public testing: string[][];
  public video: string[][];
  public poline;
  public batchline;
  public batteryHealth;
  public batteryLife;
  public mdm;
  public computrace;
  //public deepSearch;
  public msgerror;
  /* bitraser */
  public raserhardware = null;
  public raserbatery = null;
  public raserdisk = null;
  public raservideo = null;
  public rasermemory = null;
  public rasernetwork = null;
  public raserprocessor = null;
  public bitrasershow = false;
  public raserhardwaretest = null;
  public attributesDataAvailable = false;
  /* endbitraser */
  /* phonecheck */
  public phonecheckinfo = null;
  public phonecheckpart = null;
  public phonecheckshow = false;
  /* endphone */
  public type;
  public showSpecsTree = false;
  public specsTree: Array<any> = [];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _service: PrincipalinventoryService,
    private _router: Router,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private _securazeService: SecurazeService,
    private mobilesdevicesService: MobilesdevicesService
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.token = JSON.parse(localStorage.getItem("token"));
    /*if (this.data) {
      this.deepSearch = this.data.deepSearch;
    }
    console.log("recibiendo data::: ", this.deepSearch);*/
  }
  get isInventoryAttributesRoute(): boolean {
    return this._router.url.includes("inventory/attributes/");
  }
  async ngOnInit() {
    if (this.deepSearch) {
      console.log(this.deepSearch);
      this.margen = "0px;";
      await Promise.all([
        this.getdatabitraser(),
        this.Phonecheck(),
        this.getpxe(),
        this.getSpecsTree(),
      ]);

      this.load();
    } else {
      if (this.serialN) {
        this.sn = this.serialN;
        this.id = this.incommingId;
        this.type = this.incommingType;
        await this.loadDataAndCheck();
      } else {
        this._route.params.subscribe(async (params) => {
          console.log(params);
          this.sn = params["sn"];
          this.id = params["id"];
          this.type = params["type"];
          /*         this.getAttributes();
            this.getdatabitraser(); */
          await this.loadDataAndCheck();
        });
      }
    }
  }

  load() {
    if (this.showSpecsTree) {
      this.showContent("tree");
    } else if (this.attributesDataAvailable || !this.specsTree) {
      this.showContent("eps");
    } else if (this.bitrasershow) {
      this.showContent("bitraser");
    } else if (this.phonecheckshow) {
      this.showContent("phonecheck");
    }
  }
  public sectionShown = "";
  public showSection = false;
  sectionShownLabel: string = "";
  showContent(section: string) {
    console.log(section, "seeec");
    this.sectionShown = section;

    const labels: Record<string, string> = {
      tree: "Tree Information",
      bitraser: "Bitraser",
      phonecheck: "Phone Check",
      eps: "EPS PXE",
    };
    this.sectionShownLabel = labels[section] || "";
  }
  get title() {
    return !this.deepSearch ? "Inventory Attributes" : "EPS PXE";
  }
  async getdatabitraser(): Promise<void> {
    this.loading = true;
    let serialnumber = this.deepSearch ? this.deepSearch : this.sn;

    this.raserhardware = null;
    this.raserbatery = null;
    this.raserdisk = null;
    this.raservideo = null;
    this.rasermemory = null;
    this.rasernetwork = null;
    this.raserprocessor = null;

    try {
      const response = await this._securazeService
        .gedatabitraser(this.token, serialnumber)
        .toPromise();
      if (response.status === "success") {
        this.bitrasershow = true;
        this.raserhardware = response.data.hardwareInfo;
        this.raserbatery = response.data.batteryInfo;
        this.raserdisk = response.data.diskInfo;
        this.raservideo = response.data.graphisInfo;
        this.raserhardwaretest = response.data.hardwareTest;
        this.rasermemory = response.data.memoryInfo;
        this.rasernetwork = response.data.networkInfo;
        this.raserprocessor = response.data.proccessorInfo;
      } else {
        this.bitrasershow = false;
      }
    } catch (error) {
      console.log(error);
      this.bitrasershow = false;
    } finally {
      this.loading = false;
    }
  }
  async Phonecheck(): Promise<void> {
    console.log("se hace el phone check", this.deepSearch, this.sn);
    this.loading = true;
    let serialnumber = this.deepSearch ? this.deepSearch : this.sn;
    /*  let testid="K9QH4CMV71" */
    this.phonecheckinfo = null;
    this.phonecheckpart = null;
    this.phonecheckshow = false;

    try {
      const response = await this.mobilesdevicesService
        .Getphonecheckdata(serialnumber)
        .toPromise();
      if (response.status === "success") {
        this.phonecheckshow = true;
        this.phonecheckinfo = response.result;
        console.log(this.phonecheckinfo);
        if (response.Parts && Array.isArray(response.Parts.Data)) {
          this.phonecheckpart = response.Parts.Data;
          /*  this.phonecheckshow = true; */
        } else {
          this.phonecheckpart = [];
        }
      } else {
        this.phonecheckshow = false;
      }
    } catch (error) {
      console.log(error);
      this.phonecheckshow = false;
    } finally {
      this.loading = false;
    }
  }
  getSpecsTree() {
    this._securazeService.getSpecsTree(this.token, this.id).subscribe(
      (response) => {
        if (response.data.children.length === 0) {
          this.showSpecsTree = false;
        } else {
          this.showSpecsTree = true;
          this.specsTree = response.data;
          if (this.specsTree) {
          }
          console.log(this.specsTree, "specstree");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  editState = {
    system: true,
    hdd: true,
    cpu: true,
    memory: true,
    testing: true,
    battery: true,
    component: true,
    network: true,
    video: true,
  };

  editModeo(section: keyof typeof this.editState) {
    this.editState[section] = !this.editState[section];
    console.log(
      `${section} ahora está ${
        this.editState[section] ? "deshabilitado" : "habilitado"
      }`
    );
  }
  getpxe() {
    this.loading = true;

    this.batteries = [];
    this.components = [];
    this.cpus = [];
    this.hdds = [];
    this.memories = [];
    this.networks = [];
    this.system = [];
    this.testing = [];
    this.video = [];

    this._service.getpxe(this.deepSearch).subscribe(
      (response) => {
        if (response.status == "success") {
          console.log("pxe", response.data);
          this.attributesDataAvailable = true;
          if (response.data.testing) {
            console.log("entra");
            if (response.data.testing.length > 0)
              this.mdm = response.data.testing[0].mdm;

            if (response.data.testing.length > 0) {
              console.log("entra 2");
              this.computrace = response.data.testing[0].computrace;
            }
          }

          if (response.data.hdds) this.hdds = response.data.hdds;

          if (response.data.memory) this.memories = response.data.memory;

          if (response.data.system) this.system = response.data.system;

          if (response.data.inventory)
            this.poline = response.data.inventory.poline;

          if (response.data.testing) {
            if (response.data.testing.length > 0)
              this.testing[0] = response.data.testing[0];
          }

          if (response.data.battery) {
            if (response.data.testing) {
              if (response.data.testing.length > 0)
                this.batteryHealth = response.data.testing[0].battery;
            }

            this.batteryLife = response.data.battery.field5;
          }

          if (response.data.video) this.video = response.data.video;

          this.batchline = response.data.batchNumber;
        } else {
          /* this.msgerror = "No records found, please try again"; */
          // this.mtds.notifyError(response.msg, response.code);
          this.getdatabitraser();
        }

        this.loading = false;
      },
      (error) => {
        console.log(<any>error);
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  editMode() {
    this.disabled = !this.disabled;
  }

  saveAttributes(id, type, remove) {
    let json = {
      id: id,
      type: type,
      idInventory: this.id,
      remove: remove,
    };

    this._service.saveAttributes(json).subscribe(
      (response) => {
        if (response.status === "success") {
          this.showToast(
            "success",
            "Inventory has been updated successfully",
            2000
          );

          if (remove === 1) this.getAttributes();
        } else {
          this.showToast(
            "error",
            "Error, inventory has not been updated",
            2000
          );
        }

        this.editMode();
      },
      (error) => {
        this.loading = false;
        this.showToast("error", "Error, inventory has not been updated", 2000);
      }
    );
  }

  async getAttributes(): Promise<void> {
    this.loading = true;

    let type;

    if (this.type === "history") type = "history";
    else type = "inventory";

    this.batteries = [];
    this.components = [];
    this.cpus = [];
    this.hdds = [];
    this.memories = [];
    this.networks = [];
    this.system = [];
    this.testing = [];
    this.video = [];

    try {
      const response = await this._service
        .getAttributes(this.id, type)
        .toPromise();
      console.log(response);

      if (response.status === "success") {
        this.attributesDataAvailable = true;
        if (response.data.testing) {
          this.mdm = response.data.testing[0].mdm;
          this.computrace = response.data.testing[0].computrace;
        }

        this.batteries = response.data.batteries;
        this.components = response.data.components;
        this.cpus = response.data.cpus;
        this.hdds = response.data.hdds;
        this.memories = response.data.memories;
        this.networks = response.data.networks;
        this.system = response.data.system;
        this.testing[0] = response.data.testing[0];
        this.video = response.data.video;
        this.poline = response.data.inventory.poline;
        this.batchline = response.data.batchNumber;
        console.log(this.components, "questapasanda", typeof this.components);
        //console.log(this.inventory);
        this.loading = false;
      } else {
        this.attributesDataAvailable = false;
        /*           this.mtds.notifyError("Inventory not found!");
          this._router.navigate(["/inventory", "product", this.id]); */
      }
    } catch (error) {
      console.log(error);
      this.attributesDataAvailable = false;
    } finally {
      this.loading = false;
    }
  }
  async loadDataAndCheck() {
    await Promise.all([
      this.getdatabitraser(),
      this.getAttributes(),
      this.Phonecheck(),
      this.getSpecsTree(),
    ]);
    if (this.showSpecsTree) {
      this.showContent("tree");
    } else if (this.attributesDataAvailable || !this.specsTree) {
      this.showContent("eps");
    } else if (this.bitrasershow) {
      this.showContent("bitraser");
    } else if (this.phonecheckshow) {
      this.showContent("phonecheck");
    }

    // if(this.Phoneche)
    // Si ambas variables indican que no hay datos, redirige
    // if (
    //   !this.bitrasershow &&
    //   !this.attributesDataAvailable &&
    //   !this.phonecheckshow
    // ) {
    //   this.mtds.notifyError("Inventory not found!");
    //   this._router.navigate(["/inventory", "product", this.id]);
    // }
  }
  remove(item, type) {
    let response = confirm("Are you sure you want to delete it?");

    if (response) this.saveAttributes(item, type, 1);
  }

  /*getAttributes(){

    this.loading = true;

    this._service.getAttributes(this.sn).subscribe(
      response => {

        console.log(response);

        if(response.status === 'success'){

          this.inventory = new InventoryAttribute(
            response.device.recid,
            response.device.manufacturer,
            response.device.model,
            response.device.serialNumber,
            response.device.serialNumber_new,
            response.device.wwn,
            response.device.capacity,
            response.device.maximumLba,
            response.device.grade,
            response.device.blockSize,
            response.device.formFactor,
            response.device.rPM,
            response.device.healthScore,
            response.device.reallocatedSectors,
            response.device.smartPowerOnHours,
            response.device.deviceSummary,
            response.device.erasureSummary,
            response.device.erasureMethod,
            response.device.erasureResults,
            response.device.erasureDuration,
            response.device.erasureStartDate,
            response.device.erasureStartTime,
            response.device.erasureEndTime,
            response.device.erasureEndDate,
            response.device.systemSerialNumber,
            response.device.ataVersion,
            response.device.scsiVersion,
            response.device.microcode,
            response.device.poNumber,
            response.system.systemName,
            response.system.processingDate,
            response.system.processingTime,
            response.system.pxeProfile,
            response.system.systemManufacturer,
            response.system.systemProductName,
            response.system.systemMac,
            response.system.systemChassisType,
            response.system.biosManufacturer,
            response.system.biosDate,
            response.system.biosVersion,
            response.system.motherboardManufacturer,
            response.system.motherboardModel,
            response.system.motherboardVersion,
            response.system.motherboardSerialNumber,
            response.system.processorInformation,
            response.system.processorManufacturer,
            response.system.processorModel,
            response.system.processorSerialNumber,
            response.system.processorSpeed,
            response.system.processorCores,
            response.system.processorType,
            response.system.memoryInformation,
            response.system.memoryManufacturer,
            response.system.memoryModel,
            response.system.memorySerialNumber,
            response.system.memorySize,
            response.system.memorySpeed,
            response.system.componentManufacturer,
            response.system.componentModel,
            response.system.componentSerialNumber,
            response.system.batteryInformation,
            response.system.batteryManufacturer,
            response.system.batterySerialNumber,
            response.system.batteryId,
            response.system.batteryBuildDate,
            response.system.batteryChemistry,
            response.system.batteryCapacity,
            response.system.batteryFullCharge,
            response.system.batteryLife,
            response.system.batteryGrade,
            response.system.videoAdapter,
            response.system.displayResolution,
            response.system.networkAdapter,
            response.system.opticalDevice,
            response.system.multimedia,
            response.system.deviceCount,
            response.system.computraceTestResults,
            response.system.burninInResultsCpu,
            response.system.burninInResultsMemory,
            response.system.systemConditionGrade,
            response.system.missingPartsAnswer1,
            response.system.physicalGradingAnswer2,
            response.system.screenGradingAnswer3,
            response.system.ataGradleFile,
            response.system.scsiGradleFile
          );

          console.log(this.inventory);
          this.loading = false;

        }else{
          this.mtds.notifyError('Inventory not found!');
          this._router.navigate(['/inventory', 'product', this.id]);
        }

      }, error => {
        this.loading = false;
        this.mtds.notifyError('Inventory not found!');
        this._router.navigate(['/inventory', 'product', this.id]); 
      }

    );
  }*/

  back() {
    if (this.type === "history")
      this._router.navigate(["/inventory", "history", this.id]);
    else if (this.type === "Inventory")
      this._router.navigate(["/inventory", "product", this.id]);
    else this._router.navigate(["/workflow-process", this.id]);
  }

  showSwal(item, type) {
    swal
      .fire({
        title: "Delete",
        text: "Are you sure you want to delete it?",
        showCancelButton: true,

        customClass: {
          confirmButton: "btn btn-danger",
        },
        confirmButtonText: "Yes",
      })
      .then(function (result) {
        if (result) {
        }
      });
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }
}
